// scroll bar
import 'simplebar-react/dist/simplebar.min.css';
// lazy image
import 'react-lazy-load-image-component/src/effects/blur.css';
// routes
import Router from 'src/routes/sections';
import { AuthProvider, AuthConsumer } from 'src/auth/context/jwt';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import MuiLayout from './layouts/MuiLayout';
import ScrollToTop from './hooks/use-scroll-to-top';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <MuiLayout>
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <AuthConsumer>
              <Router />
            </AuthConsumer>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </MuiLayout>
  );
}
